/* eslint-disable react/prop-types */
import { FC, useEffect } from "react";

import { mapLoaded } from "../RoadViewMap/util";
import { useLocationContext } from "../../locationContext";

import { MAP_ID } from "constants/configConstants";

declare let google: any;

export const StreetViewMap: FC<any> = ({ data }) => {
  const { map, setMap } = useLocationContext();

  useEffect(() => {
    initializeMap();
  }, []);

  useEffect(() => {
    if (map) buildMap();
  }, [map]);

  const initializeMap = () => {
    if (mapLoaded("street-map-view")) {
      const center = new google.maps.LatLng(
        data.location_coordinates.lat,
        data.location_coordinates.lng,
      );

      const mapOptions = {
        mapId: MAP_ID,
        scrollwheel: false,
        zoom: 8,
        center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };

      setMap(new google.maps.Map(document.getElementById("street-map-view"), mapOptions));
    }
  };

  const buildMap = () => {
    if (mapLoaded("street-map-view")) {
      if (
        data.location_coordinates &&
        data.location_coordinates.lat &&
        data.location_coordinates.lng
      ) {
        const position = new google.maps.LatLng(
          data.location_coordinates.lat,
          data.location_coordinates.lng,
        );
        map.getStreetView().setPosition(position);
        map.getStreetView().setVisible(true);

        map.panTo(position);
      }
    }
  };

  return <div id="street-map-view" style={{ height: "100%", width: "100%", overflow: "hidden" }} />;
};

export default StreetViewMap;
